export const colorPalette = {
    owner_occupied_count : {
        colorPalette: [
            {
              color: '#FDB4C2'
            },
            {
              color: '#FC6A86'
            },
            {
              color: '#FB204A'
            },
            {
              color: '#D11A3D'
            },
            {
              color: '#7D1025'
            }]
    },
    average_job_size: {
      colorPalette: [
          {
            color: '#E2FFEE'
          },
          {
            color: '#52D586'
          },
          {
            color: '#029C40'
          },
          {
            color: '#096831'
          },
          {
            color: '#05401d'
          },
        ]
  },
    close_rate: {
        colorPalette: [
            {
              color: '#FFE1D1'
            },
            {
              color: '#F89966'
            },
            {
              color: '#ce5415'
            },
            {
              color: '#8f3c0f'
            },
            {
              color: '#70300b'
            },
          ]
    },
    retail_status:{
        colorPalette:[
            {
                color: "rgb(255, 222, 1)"
            },
            {
                color: "rgb(224, 150, 45)"
            }
        ]
    },
    cancellation_rate: {
      colorPalette: [
        {
          color: '#FFE1D1'
        },
        {
          color: '#F89966'
        },
        {
          color: '#ce5415'
        },
        {
          color: '#8f3c0f'
        },
        {
          color: '#70300b'
        },
      ]
    },
    penetration_rate:{
      colorPalette: [
        {
          // color: '#FFE1D1'
          color: '#fff6f2'
        },
        {
          color: '#FFDCCB'
        },
        {
          color: '#FFBA98'
        },
        {
          color: '#FF9966'
        },
        {
          color: '#FF7836'
        },
        {
          color: '#EF6018'
        },
        {
          color: '#CF5415'
        },
        {
          color: '#AF4811'
        },
        {
          color: '#8F3C0E'
        },
      ]
    },
    tier_1_percentage:{
      colorPalette: [
        {
          color: '#FFE1D1'
        },
        {
          color: '#F89966'
        },
        {
          color: '#ce5415'
        },
        {
          color: '#8f3c0f'
        },
        {
          color: '#70300b'
        },
      ]
    },
    tier_2_percentage:{
      colorPalette: [
        {
          color: '#FFE1D1'
        },
        {
          color: '#F89966'
        },
        {
          color: '#ce5415'
        },
        {
          color: '#8f3c0f'
        },
        {
          color: '#70300b'
        },
      ]
    },
    tier_3_percentage: {
      colorPalette: [
        {
          color: '#FFE1D1'
        },
        {
          color: '#F89966'
        },
        {
          color: '#ce5415'
        },
        {
          color: '#8f3c0f'
        },
        {
          color: '#70300b'
        },
      ]
    },
    tier_4_percentage: {
      colorPalette: [
        {
          color: '#FFE1D1'
        },
        {
          color: '#F89966'
        },
        {
          color: '#ce5415'
        },
        {
          color: '#8f3c0f'
        },
        {
          color: '#70300b'
        },
      ]
    },
    opps:{
      colorPalette: [
        {
          color: '#E2FFEE'
        },
        {
          color: '#52D586'
        },
        {
          color: '#029C40'
        },
        {
          color: '#096831'
        },
        {
          color: '#05401d'
        },
      ]
    },
    cumulative_1_2_3_percentage:{
      colorPalette: [
        {
          color: '#E2FFEE'
        },
        {
          color: '#52D586'
        },
        {
          color: '#029C40'
        },
        {
          color: '#096831'
        },
        {
          color: '#05401d'
        },
      ]
    },

}